import React, { useEffect } from "react";
import ShopifyHomepage from "../Components/ShopifyHomepage"
import GetInTouch from '../Components/GetInTouch'
import ServiceAccordion from '../Components/ServiceAccordion'
import HowWeWork from '../Components/HowWeWork'
import ActivePostsSection from '../Components/ActivePostsSection'
import TestimonialSlider from '../Components/TestimonialSlider'
import ProductHoverSection from '../Components/ProductHoverSection'
import MarqueeSection from '../Components/MarqueeLogoSection '
import PostList from '../Components/PostList'
export default function ShopifyShowcase() {
  useEffect(() => {
    // Check if the URL has a hash when the component mounts or re-renders
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash); // Find the element with the ID
      if (element) {
        element.scrollIntoView({ behavior: "smooth" }); // Scroll to it smoothly
      }
    }
  }, []);

  return (
<>

<ShopifyHomepage/>

{/* <HowWeWork/> */}
<MarqueeSection/>
<ProductHoverSection/>

<ActivePostsSection/>
{/* <ServiceAccordion/> */}
<TestimonialSlider/>
<GetInTouch/>
</>
  )
}
